import React from 'react'
import { Block, FilteredList } from '@components'

const FilteredBlogList = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <FilteredList {...props} />
    </Block>
  )
}

export default FilteredBlogList
